const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/ideas/completed/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
const searchSchema = z.object({
  ideaId: z.number().optional(),
  eventId: z.number().optional()
});
export const Route = createFileRoute('/(app)/org/$org/intake/ideas/completed/')({
  validateSearch: search => searchSchema.parse(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.ideaManagement.general.completedIdeas)
    }
  }
});